import axiosInstance from './axiosInstance';

// Agent requests one or more payment links for a sale.
// payload: { salesId, bank, paymentMethod, amount, numLinks }
export const requestPaymentLink = (payload) =>
    axiosInstance.post('/PaymentLink/Request', payload);
